import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    loading: false,
    error: false,
    success: false
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, error: false, success: false });
    
    // Simulate form submission - replace with actual API call
    setTimeout(() => {
      // Form validation would go here
      setFormStatus({ loading: false, error: false, success: true });
      
      // Reset form after success
      setTimeout(() => {
        setFormStatus({ loading: false, error: false, success: false });
        setFormData({ name: '', mobile: '', email: '', subject: '', message: '' });
      }, 3000);
    }, 1500);
  };
  
  return (
    <section id="contact" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Ready to Transform Your Business?</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Contact our team to discuss how our IT solutions can address your specific challenges and unlock new opportunities for growth.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-12 max-w-6xl mx-auto">
          <div>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-bold mb-4 text-white">Email Us</h3>
                <a href="mailto:support@ramwintech.com" className="text-blue-400 hover:text-blue-300 font-semibold text-lg">
                  support@ramwintech.com
                </a>
              </div>
              
              <div>
                <h3 className="text-xl font-bold mb-4 text-white">Call Us</h3>
                <div className="space-y-3">
                  <a 
                    href="tel:+918939921400" 
                    className="text-blue-400 hover:text-blue-300 font-semibold text-lg flex items-center gap-2"
                  >
                    <FaPhone className="text-base" />
                    +91 89399 21400
                  </a>
                  <div>
                    <a 
                      href="https://wa.me/918939921400" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl mt-2"
                    >
                      <FaWhatsapp className="text-xl" />
                      Chat on WhatsApp
                    </a>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-bold mb-4 text-white">Book a Meeting</h3>
                <a 
                  href="https://outlook.office.com/book/RamwinTechnology@conqudel.com/s/vmEKvjyBgE6WzbP9OHSxhw2?ismsaljsauthenabled=true" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 font-semibold"
                >
                  Schedule a time →
                </a>
              </div>
              
              <div className="dark-card rounded-xl p-6">
                <div className="flex items-start">
                  <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg p-3 mr-4">
                    <FaMapMarkerAlt className="text-2xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2 text-white">Our Address</h3>
                    <p className="text-gray-300 leading-relaxed">
                      Ramwin Technology Private Limited <br/>
                      Matwari, Hazaribag, <br/> Jharkhand,<br/> India 825301
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="dark-card rounded-xl p-8 relative z-10">
            <h3 className="text-2xl font-bold mb-6 text-white">Get in Touch</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <input 
                  type="text" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-slate-800 border border-blue-500 border-opacity-30 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                  placeholder="Name" 
                  required 
                />
              </div>
              
              <div className="mb-4">
                <input 
                  type="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-slate-800 border border-blue-500 border-opacity-30 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                  placeholder="Email" 
                  required 
                />
              </div>
              
              <div className="mb-4">
                <input 
                  type="text" 
                  name="subject" 
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-slate-800 border border-blue-500 border-opacity-30 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                  placeholder="Subject" 
                  required 
                />
              </div>
              
              <div className="mb-4">
                <textarea 
                  name="message" 
                  value={formData.message}
                  onChange={handleChange}
                  rows="5" 
                  className="w-full px-4 py-3 bg-slate-800 border border-blue-500 border-opacity-30 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                  placeholder="Message" 
                  required
                ></textarea>
              </div>
              
              <div className="mb-4 h-8">
                {formStatus.loading && <div className="text-blue-400">Sending your message...</div>}
                {formStatus.error && <div className="text-red-400">There was an error. Please try again.</div>}
                {formStatus.success && <div className="text-green-400">Your message has been sent. Thank you!</div>}
              </div>
              
              <div>
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg shadow-blue-500/30"
                  disabled={formStatus.loading}
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;